export default __webpack_public_path__ + "static/media/localization.icon.a6d3e886.svg";